'use strict';
import React from 'react';
import flux from 'utils/flux';
import {Link} from 'react-router';
import { Navigation } from 'react-router';

var BasketSidebar = React.createClass({

    displayName: 'BasketSidebar',

    mixins: [
        Navigation
    ],

    propTypes: {
        name: React.PropTypes.string.isRequired,
        baskets: React.PropTypes.object.isRequired,
        basket: React.PropTypes.object
    },

    _getSelectedBasketIds() {
        return this._getSelectedBaskets().map((basket) => basket.get('id'));
    },

    _getSelectedBaskets() {
        return this.props.baskets.filter((basket) => basket.get('isSelected'));
    },

    deleteBaskets(e) {
        e.preventDefault();
        var baskets = this._getSelectedBaskets();
        var basketIdsToDelete = baskets.map( basket => basket.get('id') );
        var basketNamesToDelete = baskets.map( basket => basket.get('name') ).toJS();

        flux.getActions('modals').confirmModal({
            title: flux.t('delete_folder'),
            basketNames: basketNamesToDelete,
            onConfirm: () => {
                flux.getStore('basket').deleteBaskets( basketIdsToDelete ).then( () => {
                    var gotToBasket = this.props.baskets.first();
                    if ( gotToBasket ) {
                        this.transitionTo( 'singleBasket', { id: gotToBasket.get('id') } );
                    } else {
                        this.transitionTo( 'basket' );
                    }

                    flux.getActions('modals').closeModals();
                });
            }
        });
    },

    shareBaskets() {
        var basketIdsToShare = this._getSelectedBasketIds();

        flux.getActions('modals').openModal('Share');
        flux.getStore('basket').shareBaskets(basketIdsToShare);
    },

    toggleBasket( basketId, e ) {
        e.preventDefault();
        flux.getActions('basket').toggleBasketSelection( basketId );
    },

    renderShareButtons() {
        var selectedBaskets = this._getSelectedBaskets();

        if ( this.props.baskets.size !== 0 ) {
            return (
                <div>
                    <h4>{flux.t('basket_selection')}</h4>

                    <div className="sidebar__buttons">
                        <button onClick={this.deleteBaskets} type="button" disabled={selectedBaskets.size === 0} className="btn btn-border btn-remove">
                            <i className="gopro-close-small"></i>
                            {flux.t('remove_baskets')}
                        </button>

                        <button type="button" onClick={this.shareBaskets} disabled={selectedBaskets.size === 0} className="btn btn-border btn-red btn-share">
                            <i className="gopro-share"></i>
                            {flux.t('share_baskets')}
                        </button>
                    </div>
                </div>
            );
        }
    },

    render() {
        var baskets = this.props.baskets.toJS();
        const { licensing } = flux.getStore('app').getState().config.toJS();

        return (
            <div className="basket__sidebar">
                {this.renderShareButtons()}
                <ul className="sidebar__menu">
                    {baskets.map( ( basket, ix ) => {
                        return (
                            <li key={'basket_' + ix} className="menu__item">
                                <form className="item__actions">
                                    <div className="field__checkbox">
                                        <input readOnly type="checkbox" id={basket.id} checked={basket.isSelected}/>
                                        <label onClick={this.toggleBasket.bind(null, basket.id)} htmlFor={basket.id}/>
                                    </div>
                                </form>
                                <Link className="item__link" to={this.props.name} params={{ id: basket.id }}>
                                    {basket.name} ({basket.items.length})
                                </Link>
                            </li>
                        );
                    })}
                </ul>
                {licensing && <div className="sidebar__requests">
                    <h4>{flux.t('my_requests')}</h4>

                    <Link to="requests">
                        {flux.t('all_requests')}
                    </Link>
                </div>}
                <Link to="listing" className="sidebar__back">
                    <i className="gopro-chevron-left"/>
                    {flux.t('back_to_home')}
                </Link>
            </div>
        );
    }
});

module.exports = BasketSidebar;



// WEBPACK FOOTER //
// ./app/components/basket/basketSidebar.jsx